export const enUS = {
  productLeaflet: 'Product Leaflet',
  productLeaflets: 'Product Leaflets',
  policyProvision: 'Policy Provision',
  policyProvisions: 'Policy Provisions',
}
